import React from 'react'
import Herosection from './Features/Herosection'
import Hamburger from './Features/Hamburger'
import PassionSection from './Features/PassionSection'

export default function Aboutcomponent() {
  return (
<>
<Herosection />
</>
    )
}
